import React, { useState, useEffect } from 'react';
import './QuizOfTheDay.css'; // Optional: for styling

const questionsData = [
    {
        question: 'What is the capital of France?',
        options: ['Berlin', 'Madrid', 'Paris', 'Lisbon'],
        answer: 'Paris',
    },
    {
        question: 'Which planet is known as the Red Planet?',
        options: ['Earth', 'Venus', 'Mars', 'Jupiter'],
        answer: 'Mars',
    },
    {
        question: 'What is 5 + 7?',
        options: ['10', '11', '12', '13'],
        answer: '12',
    },
    {
        question: 'Which gas do plants use for photosynthesis?',
        options: ['Oxygen', 'Carbon Dioxide', 'Nitrogen', 'Helium'],
        answer: 'Carbon Dioxide',
    },
    // Add more questions as needed
];

function QuizOfTheDay() {
    const [selectedAnswers, setSelectedAnswers] = useState({});
    const [feedback, setFeedback] = useState({});
    const [quizQuestions, setQuizQuestions] = useState([]);
    const [score, setScore] = useState(0);

    useEffect(() => {
        generateRandomQuestions(); // ✅ Use a separate function for reusability
    }, []);


    // ✅ New function to reset quiz state
    const generateRandomQuestions = () => {
        const shuffled = [...questionsData].sort(() => 0.5 - Math.random());
        setQuizQuestions(shuffled.slice(0, 3));
        setSelectedAnswers({});
        setFeedback({});
        setScore(0); // ✅ Reset score
    };

    const handleAnswer = (questionIndex, option) => {
        const isCorrect = quizQuestions[questionIndex].answer === option;

        // Prevent re-answering the same question
        if (selectedAnswers[questionIndex]) return;

        setSelectedAnswers({
            ...selectedAnswers,
            [questionIndex]: option,
        });

        setFeedback({
            ...feedback,
            [questionIndex]: isCorrect ? 'Correct!' : 'Incorrect ❌',
        });

        if (isCorrect) {
            setScore(score + 1); // ✅ Update score if correct
        }
    };

    // ✅ Retry handler
    const handleRetry = () => {
        generateRandomQuestions();
    };

    return (
        <div className="quiz-container" >
            <h2 className='section-title'>🧠 Quiz of the Day</h2>
            {quizQuestions.map((q, index) => (
                <div key={index} className="quiz-question">
                    <p><strong>Q{index + 1}:</strong> {q.question}</p>
                    <div className="options">
                        {q.options.map((option) => (
                            <button
                                key={option}
                                className={`option-button ${selectedAnswers[index] === option
                                        ? feedback[index] === 'Correct!'
                                            ? 'correct'
                                            : 'wrong'
                                        : ''
                                    }`}
                                onClick={() => handleAnswer(index, option)}
                                disabled={selectedAnswers[index]}
                            >
                                {option}
                            </button>
                        ))}
                    </div>
                    {feedback[index] && (
                        <p
                            className={`feedback ${feedback[index] === 'Correct!' ? 'correct' : 'wrong'
                                }`}
                        >
                            {feedback[index]}
                        </p>
                    )}

                </div>
            ))}
            {/* ✅ Add score and retry button here */}
            <div className="quiz-footer">
                <h3>✅ Your Score: {score} / {quizQuestions.length}</h3>
                <button className="retry-button" onClick={handleRetry}>
                    🔁 Retry Quiz
                </button>
            </div>
        </div>
    );
}

export default QuizOfTheDay;
